/* eslint-disable no-undef */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Mulika...
mulika.debug = false;
mulika.start();

ReactDOM.render(
  // <React.StrictMode>
    <App />,
  // </React.StrictMode>,
  document.getElementById('root')
);




const people = 10;
mulika.typeCheck({type: 'number', value: people});

